<template>
	<div>
		<div class="row">
			<div class="col-9 mb-4 d-flex align-items-center">
				<h1 class="mb-0">{{ $t("timetables") }}</h1>
			</div>
			<div class="col-3">
				<b-dropdown class="float-right" :text="$t('add')" variant="primary" v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')">
					<b-dropdown-item @click="$router.push('/timetables/settings')">{{ $t("timetable") }}</b-dropdown-item>
					<b-dropdown-item @click="$router.push('/timetables/session-types/add')">{{ $t("session-type") }}</b-dropdown-item>
					<!-- <b-dropdown-item @click="addItem">Session Type Room</b-dropdown-item> -->
					<b-dropdown-item @click="$router.push('/timetables/rooms/add')">{{ $t("room") }}</b-dropdown-item>
					<b-dropdown-item @click="$router.push('/timetables/buildings/add')">{{ $t("building") }}</b-dropdown-item>
					<b-dropdown-item @click="$router.push('/timetables/templates/add')">{{ $t("template") }}</b-dropdown-item>
				</b-dropdown>
			</div>
		</div>

		<div class="row">
			<div class="col-12 col-lg-8 mb-4">
				<Table
					:loading="!loaded"
					:skeletonLength="10"
					:cols="[
						{ key: 'name', heading: $t('name'), size: 4 },
						{ key: 'statustext', heading: $t('status'), size: 2 },
						{ key: 'datefrom', heading: $t('from'), size: 3, cb: (tt) => tt.datefrom.split('-').reverse().join('/') },
						{ key: 'dateto', heading: $t('to'), size: 3, cb: (tt) => tt.dateto.split('-').reverse().join('/') },
					]"
					:data="timetables"
					breakpoint="sm"
					@selectItem="selectTimetable"
				>
					<template #header>
						<div class="list-group-item">
							<CheckboxInput
								v-model="showDrafts"
								:label="$t('show-drafts')"
                                class="text-right"
							/>
						</div>
					</template>
				</Table>
			</div>
			<!-- <div class="col-12 col-lg-6 order-lg-12 mb-4">
				<SessionTypeRoomsWidget header="Session Type Rooms" />
			</div> -->

			<div class="col-12 col-lg-4 mb-4">

				<div class="list-group border-radius-2 no-border mb-3">
					<div class="list-group-item">
						<h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t("individual-timetables") }}</h2>
					</div>
					<router-link :to="`/timetables/individualteacher/${$UserSession.getValue('id')}`" class="list-group-item">{{ $t('my-timetable') }}</router-link>
					<router-link to="/timetables/individual/" class="list-group-item">{{ $t('view') }}</router-link>
					<router-link to="/timetables/absences/" class="list-group-item">{{ $t('absences') }}</router-link>
					<router-link to="/timetables/staff/" class="list-group-item">{{ $t('teacher-timetables') }}</router-link>
				</div>

				<div class="list-group border-radius-2 no-border mb-3" v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')">
					<div class="list-group-item">
						<h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t("settings") }}</h2>
					</div>
					<router-link to="/timetables/session-types" class="list-group-item">{{
						$t("session-types")
					}}</router-link>
					<router-link to="/timetables/rooms" class="list-group-item">{{
						$t("rooms")
					}}</router-link>
					<router-link to="/timetables/buildings" class="list-group-item">{{
						$t("buildings")
					}}</router-link>
					<router-link to="/timetables/templates" class="list-group-item">{{
						$t("templates")
					}}</router-link>
					<router-link to="/timetables/dateranges" class="list-group-item">{{
						$t("teacher-rotas")
					}}</router-link>
					<router-link to="/placement-providers" class="list-group-item" v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')">{{
						$t("placement-providers")
					}}</router-link>
                    <router-link to="/reports/signoff-anomalies" class="list-group-item" v-if="$UserSession.hasPriv.call(this, 'PLACEMENT_CHECK_ATTENDANCE')">{{
						$t("signoff-anomalies")
					}}</router-link>
					<router-link to="/timetables/generator" class="list-group-item" v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')">{{
						$t("generate-events")
					}}</router-link>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import Table from "../../components/Table/Table.vue";
import CheckboxInput from "../../components/Inputs/CheckboxInput.vue";


export default {
	components: {
		Table,
		CheckboxInput,
	},
	data() {
		return {
			timetables: [],
			loaded: false,
			showDrafts: this.$config.getValue('ttshowdraftsbydefault') || false,
		};
	},
	watch: {
		showDrafts() {
			this.loaded = false;
			this.fetchTimetables().then(() => {
				this.loaded = true;
			});
		},
	},
	mounted() {
		this.fetchTimetables().then(() => {
			this.loaded = true
		})
	},
	methods: {
		fetchTimetables() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttimetable/list` , {
				data: { limit: 50, view_drafts: this.showDrafts}
			}).then((json) => {
				if (json.status === "SUCCESS") {
					this.timetables = json.results;
				}
			})
		},
		selectTimetable(item) {
			this.$router.push(`/timetables/edit/${item.id}`);
		}
	},
};
</script>
